export default {
  title: 'Eseményáruház',
  productPage: 'Termékoldal',
  qty: 'Menny.',
  button: {
    edit: 'Szerkesztés',
    add: 'Kosárba',
  },
};
